import React from 'react';
import Pricing from './Pricing'; // Import the refactored Pricing component

const InternachiPricing = () => {
  const discountFactor = 0.9; // 10% discount
  const discountMessage =
    'Exclusive 10% discount for InterNACHI® members applied!';

  return (
    <Pricing
      discountFactor={discountFactor}
      discountMessage={discountMessage}
    />
  );
};

export default InternachiPricing;
